import React from 'react'

import { Button, ButtonProps } from './Button'

export const AnchorButton = ({ children, ...props }: ButtonProps) => (
  <Button {...props} as="a">
    {children}
  </Button>
)
